import { createSelector } from '@reduxjs/toolkit';

import { ChairishSimilarItemsSlice } from '@/redux/modules/chairishSimilarItems/chairishSimilarItems.types';
import { GlobalState } from '@/redux/store';

const chairishSimilarItemsSlice = (state: GlobalState): ChairishSimilarItemsSlice => state.chairishSimilarItems;

const idSelector = (_: GlobalState, id: number) => id;

const byIdSelector = createSelector(chairishSimilarItemsSlice, (state) => state.byId);
const loadedSelector = createSelector(chairishSimilarItemsSlice, (state) => state.loaded);

export const getChairishSimilarItems = createSelector([byIdSelector, idSelector], (byId, id) => byId[id] || []);

export const getIsChairishSimilarItemsLoaded = createSelector(
    [loadedSelector, idSelector],
    (loaded, id) => id in loaded
);

export const shouldFetchChairishSimilarItems = createSelector(
    [chairishSimilarItemsSlice, idSelector],
    (state, key) => !(key in state.loaded) && !state.loading
);
